import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class PromoProductFamilyProduct extends BaseEntity {
  
  promoProductFamilyCode  : string;
  product                 : Product;
  sequence                : number;
  promoRate               : number;

    constructor() {
      super()
    }
}
